exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.banner[data-v-38ba4ea0] {\n  background-color: #06E9F4;\n  height: 120px;\n  width: 100%;\n  transition: background-color .3s;\n}\n.banner .btn.inv.dark[data-v-38ba4ea0] {\n    width: 100%;\n    font-size: inherit;\n    padding: 0.5em;\n    line-height: 1;\n    height: auto;\n}\n.banner.govcloud[data-v-38ba4ea0] {\n    background-color: #ff405c;\n    color: #ffffff;\n}\n.banner.govcloud .btn.inv.dark[data-v-38ba4ea0] {\n      color: #ffffff;\n      border-color: #ffffff;\n}\n.banner.govcloud .btn.inv.dark[data-v-38ba4ea0]:hover {\n        background-color: #e8184b;\n}\n.banner.govcloud .govcloud-secure[data-v-38ba4ea0] {\n      padding-top: 8px;\n      font-size: 16px;\n      font-weight: bold;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-38ba4ea0","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/sass-resources-loader/lib/loader.js?{"resources":"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss"}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Banner.vue
// module id = 416
// module chunks = 1